import React from "react";
import { JobStatus } from "@utils/enums";
import { Badge } from "react-bootstrap";
const badgeColorMapping = {
    [JobStatus.NEW]: "primary",
    [JobStatus.VALIDATED]: "secondary",
    [JobStatus.IN_PROGRESS]: "info",
    [JobStatus.FAILED]: "warning",
    [JobStatus.APP_ERROR]: "danger",
    [JobStatus.FINISHED]: "success"
};
const JobStatusNameMapping = {
    [JobStatus.NEW]: "New",
    [JobStatus.VALIDATED]: "Validated",
    [JobStatus.IN_PROGRESS]: "In progress",
    [JobStatus.FAILED]: "Failed",
    [JobStatus.APP_ERROR]: "Application error",
    [JobStatus.FINISHED]: "Finished"
};
const StatusIcon = (props) => (React.createElement(Badge, { variant: badgeColorMapping[props.status] }, JobStatusNameMapping[props.status]));
export default StatusIcon;
